(async () => {
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('main-header', class extends baseComponent.default {
    elements = {
      nav: 'main-nav',
      inner: '.\\#main-header-inner'
    };

    render() {
      this.on('stickyMainHeader', (e, { sticky }) => {
        if(sticky) {
          this.classList.add('@sticky');
          // mm-changes: reserve the full .#main-header-inner height so
          // page content doesn't shift up when the inner becomes
          // position:fixed (the legacy code only reserved $nav height,
          // which leaves a gap under the single-row layout).
          const reserve = (this.$inner || this.$nav)?.offsetHeight || 0;
          document.body.style.setProperty('--sticky-header-offset', `${reserve}px`);
        } else {
          this.classList.remove('@sticky');
          document.body.style.setProperty('--sticky-header-offset', '0px');
        }
      })
    };
  });
})();